import { SET_DRAWER_SIZE } from '../actionTypes';
import { editTemplateViewActions } from '../reducer';

export default (value) => editTemplateViewActions[SET_DRAWER_SIZE](value);
